
import { defineComponent } from 'vue';
import ReportOptionComponent from '@/components/reportsComponents/ReportOption.vue';
import GateWaysList from '@/views/GateWaysList.vue';
import SystemGateways from '@/views/SystemGateways.vue';

export default defineComponent({
    name: "IpgListPage",

    components: { ReportOptionComponent, GateWaysList, SystemGateways },

    data() {
        return {
            statusComponent: "Menu",
            options: [
                {
                    title: " درگاه های کاربران",
                    path: "gateways",
                    icon: 'mdi-credit-card'
                },
                {
                    title: " درگاه های سیستمی",
                    path: "systemGateways",
                    icon: 'mdi-credit-card'
                },
            ]
        }
    },

    created() {
        this.syncStatusComponent(this.$route.query.path);
    },

    methods: {
        syncStatusComponent(path: unknown): void {
            this.statusComponent =
                path === "gateways" || path === "systemGateways" ? path : "Menu";
        },

        changeStatusComponent(status: string): void {
            const isGatewayList = status === "gateways" || status === "systemGateways";
            this.statusComponent = isGatewayList ? status : "Menu";
            this.$router.push({
                query: { ...this.$route.query, path: isGatewayList ? status : undefined },
            });
        },

        resetStatusComponent(): void {
            this.statusComponent = "Menu";
        },

        selectedOption(option: { title: string, path: string, icon: string }): void {
            this.changeStatusComponent(option.path)
        }
    },

    // Watch for route changes to update statusComponent
    watch: {
        "$route.query.path"(newPath: unknown) {
            this.syncStatusComponent(newPath);
        },
    },
})
